import React, { useState } from 'react'
import { ButtonToolbar, Panel } from 'rsuite'
import MiniProjectInfo from '../projectBasedItemsWidget/MiniProjectInfo'
import StrategyRegisterTable from './StrategyRegisterTable'
import { doneLoading, startLoading } from '../../utils/loading'
import OverlayLoader from '../../components/OverlayLoader/OverlayLoader'
import { exportStrategy, updateSubStrategy } from '../../redux/actions/strategyRegister'
import { SAVE_ERR_MSG, SAVE_SUCCESS_MSG } from '../../constants/msgText'
import notification from '../../utils/notification'
import { sessionGetItemStr } from '../../utils/sessionHelpers'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import { downloadFile } from '../../utils/fileUtil'

export default function StrategyRegisterWidget(props) {
  const { isEdit } = props
  const [formSchema, setFormSchema] = useState(props.schema)
  const [isLoading, setIsLoading] = useState()

  const projectCode = sessionGetItemStr('projectCode')

  const handleSave = async (request) => {
    setIsLoading(true)
    startLoading()
    try {
      // console.log('request ', request)
      const response = await updateSubStrategy(projectCode, request)
      // console.log('response ', response)

      if (response?.model) {
        setFormSchema(response.model)

        notification.open('success', {
          title: SAVE_SUCCESS_MSG,
          duration: 5000,
        })
      } else {
        notification.open('error', {
          title: SAVE_ERR_MSG,
          duration: 5000,
        })
      }
    } catch (error) {
      notification.open('error', {
        title: SAVE_ERR_MSG,
        duration: 5000,
      })
    }
    doneLoading()
    setIsLoading(false)
  }

  const onSubmitExport = async () => {
    console.log('projectCode => ', projectCode)

    setIsLoading(true)
    startLoading()
    try {
      const file = await exportStrategy(projectCode)

      if (file) {
        downloadFile(file, file.name || `ทะเบียนยุทธศาสตร์_${projectCode}.xlsx`)
      }
    } catch (e) {
      console.error('err => ', e)
    }
    setIsLoading(false)
    doneLoading()
  }

  return (
    <Panel shaded collapsible defaultExpanded header={formSchema?.header} bordered>
      <MiniProjectInfo schema={formSchema?.projectInfo} />
      <br />

      <div style={{ textAlign: 'right' }}>
        <ButtonToolbar>
          <SaveButton
            size="sm"
            icon="file-excel-o"
            children={'Export Excel'}
            onClick={() => {
              onSubmitExport()
            }}
          />
        </ButtonToolbar>
      </div>
      <StrategyRegisterTable schema={formSchema?.activity} isEdit={isEdit} onSave={handleSave} />
      {isLoading && <OverlayLoader />}
    </Panel>
  )
}
